import cn from "classnames"
import { RenderBardWithComponents } from "components/Wysiwyg"
import { DynamicHeadline } from "../DynamicHeadline"
import Image from "../Image"
import Section, { parseColors } from "../Section"
import styles from "./Partners.module.scss"

export const Partners = ({ data = {}, colors }) => {
  const {
    partners_text: text,
    partner_entries,
    dynamic_headline: dynamicHeadline,
    headline_type: headlineType,
    headline_appearance: headlineAppearance,
    ankerslug,
  } = data

  const partners = partner_entries.sort((a, b) =>
    a?.logo?.path?.localeCompare(b?.logo?.path)
  )

  // chunk partners into lines
  const maxLines = 3
  const partnersPerLine = partners.length / maxLines
  const lines = []
  for (let i = 0; i < partners.length; i += partnersPerLine) {
    lines.push(partners.slice(i, i + partnersPerLine))
  }

  const { isLightBackground } = parseColors({ colors })

  return (
    <>
      <Section
        sectionSpacing={{
          top: data?.section_padding_top?.value || null,
          bottom: data?.section_padding_bottom?.value || null,
        }}
        id={ankerslug}
        colors={colors}
        outsideContainer={
          <>
            {lines.map((line, i) => (
              <div
                key={`gs-line-${i}`}
                className={cn(styles.marquee, {
                  [styles.inverted]: !isLightBackground,
                })}
              >
                {[0, 1].map((i) => (
                  <ul
                    key={i}
                    className={styles.marquee__content}
                    aria-hidden={i === 1}
                  >
                    {line.map((partner, i) => {
                      return (
                        partner.logo && (
                          <li key={i} className={styles.imageWrapper}>
                            <Image
                              className={styles.image}
                              src={partner.logo.permalink}
                              alt={partner.logo.alt}
                              width={partner.logo.width}
                              height={partner.logo.height}
                              layout="responsive"
                              placeholder="empty"
                            />
                          </li>
                        )
                      )
                    })}
                  </ul>
                ))}
              </div>
            ))}
          </>
        }
      >
        {dynamicHeadline || text?.length > 0 ? (
          <div className="mb-20 md:w-2/3">
            <DynamicHeadline
              headlineType={headlineType.value}
              headlineAppearance={headlineAppearance.value}
            >
              {dynamicHeadline}
            </DynamicHeadline>

            {text?.length > 0 && (
              <div className="relative">
                <RenderBardWithComponents
                  content={text}
                  prefix="partners_text_"
                />
              </div>
            )}
          </div>
        ) : null}
      </Section>
    </>
  )
}

export default Partners
